// Маппинг цветов Yandex Tracker
export const colorMap: Record<string, string> = {
  red: '#e60000',
  green: '#00aa00',
  blue: '#0066ff',
  yellow: '#ccaa00',
  orange: '#ff8800',
  purple: '#8800aa',
  pink: '#ff0066',
  gray: '#888888',
  grey: '#888888',
  black: '#000000',
  white: '#ffffff',
  cyan: '#00aaaa',
  magenta: '#aa00aa',
  color: 'inherit',
};
